import { ModalHeader, type StackProps } from '@chakra-ui/react';

export type UiModalHeaderProps = StackProps;

export const UiModalHeader = ModalHeader;
